import axios from "axios";
import {
  PROGRESS_GET_REQUEST,
  PROGRESS_GET_SUCCESS,
  PROGRESS_GET_FAIL,
  PROGRESS_UPDATE_MODULE_REQUEST,
  PROGRESS_UPDATE_MODULE_SUCCESS,
  PROGRESS_UPDATE_MODULE_FAIL,
  PROGRESS_RECORD_FINAL_QUIZ_REQUEST,
  PROGRESS_RECORD_FINAL_QUIZ_SUCCESS,
  PROGRESS_RECORD_FINAL_QUIZ_FAIL,
} from "../constants/quizConstants";
import createAuthConfig from "../utils/createAuthConfig";

const API_URL = process.env.REACT_APP_API_URL;

/**
 * Fetches the user's progress document. If one doesn't exist, the backend creates it.
 */
export const getProgressAction = () => async (dispatch) => {
  try {
    dispatch({ type: PROGRESS_GET_REQUEST });

    const config = createAuthConfig();
    const { data } = await axios.get(
      `${API_URL}/api/art-of-looking/progress`,
      config
    );

    dispatch({
      type: PROGRESS_GET_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: PROGRESS_GET_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

/**
 * Updates the progress for a single module.
 * @param {string} moduleId - The Sanity _id of the module.
 * @param {number} progress - The new progress percentage (0-100).
 */
export const updateModuleProgressAction =
  (moduleId, progress) => async (dispatch) => {
    try {
      dispatch({ type: PROGRESS_UPDATE_MODULE_REQUEST });

      const config = createAuthConfig();
      const { data } = await axios.put(
        `${API_URL}/api/art-of-looking/progress/module`,
        { moduleId, progress },
        config
      );

      dispatch({
        type: PROGRESS_UPDATE_MODULE_SUCCESS,
        payload: data,
      });
      return data;
    } catch (error) {
      dispatch({
        type: PROGRESS_UPDATE_MODULE_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

/**
 * Records the score for the final quiz.
 * @param {number} score - The user's final score percentage.
 */
export const recordFinalQuizAction = (score) => async (dispatch) => {
  try {
    dispatch({ type: PROGRESS_RECORD_FINAL_QUIZ_REQUEST });

    const config = createAuthConfig();
    const { data } = await axios.post(
      `${API_URL}/api/art-of-looking/progress/final-quiz`,
      { score },
      config
    );

    dispatch({
      type: PROGRESS_RECORD_FINAL_QUIZ_SUCCESS,
      payload: data,
    });
    return data;
  } catch (error) {
    dispatch({
      type: PROGRESS_RECORD_FINAL_QUIZ_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};
